module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block8"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Ronin")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p212"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("K")]), _vm._v("en’s prick face still scrolls through my brain as I watch her gather her things. When I don’t answer her question, she shifts, and the shiny satin of her red blouse shimmers in the bright light of the office as she moves. When she turns away I watch her hips sway. The truth is that I memorized how the swell of her hips squeezed into the black pencil skirt the second I’d turned around and caught her watching me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("I know she’s expecting me to leave, but something she said at the wedding is weighing on me. And hell, I did tell Jeremy I would look out for her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("“Olive.” My voice is muted, quiet, so I don’t startle her. “Did everything go okay…in Europe?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("She sucks in another breath before finally lifting her head and straightening. But the brief shuttered expression on her face was clear as day, and I shake my head in response before she even opens her mouth.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“Hey.” My voice firms up just a little bit. Protectiveness surges to the surface inside me, pushing me forward. “Tell me what happened.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("The need to take control, to make her tell me what’s wrong, is strong. But I force myself to stay put, to keep my distance, because the last thing I need in my life is someone to fix.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("Not that I’d be any good at it, anyway.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("But I can’t deny the pull I’m feeling, the fact that I "), _c('i', [_vm._v("want")]), _vm._v(" to fix whatever it is that’s making that pretty little mouth of hers frown. Something’s churning up inside her, and I can’t beat back the need I have to know exactly what it is.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("She grabs a stack of paper off her desk, stuffs it into her laptop bag, and yanks her purse out from a drawer. Her arms full of her stuff, she rounds her desk and walks right into my space. Her eyes flash, and I take a second to appreciate the direct contrast they are to her creamy pale skin and her auburn hair.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_c('i', [_vm._v("Goddamn, the woman is fucking gorgeous.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("“Has anyone ever told you you’re one nosey, bossy brute of a man?” The stubborn set of her mouth causes her dimples to deepen as she takes a step toward me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("I slowly nod my head and a reluctant smile quirks my lips upward. “Maybe I’ve heard it a time or two.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("She lifts her chin the slightest bit as a rush of color fills her cheeks, and I can’t help it when my body reacts to her. Her closeness, the brush of her chest against mine, the wafting scent of peaches that rushes over me. I blink, taken completely off guard.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_c('i', [_vm._v("Shit. When’s the last time a woman caught me off guard?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("She makes a sound that’s halfway between a snort and a groan before brushing past me and heading for the door.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("“Olive.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("She turns slowly, and when her eyes lift to mine there’s something there I can’t pinpoint. Interest? Curiosity? Longing?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("I take two strides and am standing directly in front of her. This time, I’ve caught "), _c('i', [_vm._v("her")]), _vm._v(" off balance, which is exactly what I wanted to do. I’m not used to feeling so on edge, and there’s a strong need inside me to see if I affect her the same way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("“After you’re done doing whatever vanilla thing you’re about to do with Ken, call me. I want to know you’re home safe.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("I scan her face. Her dark red hair is piled up on top of her head and there’s not a single strand hanging around her face for me to tuck or stroke. Instead of touching her, I just let my eyes blaze a trail over her face, down her creamy throat dipping into the vee of her shirt where her top button lies undone. If I leaned over slightly, I’d probably be able to see what she’s wearing underneath, but I can wait for that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_c('i', [_vm._v("Wait for that? What the hell are you thinking, Ronin? This is one woman you won’t be taking to bed. Too many complications.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("Her cheeks flush, and I watch the stain spread down to her neck and chest. Her pupils dilate, and Olive can pretend all damn day like there’s nothing between us, but her body can’t tell a lie.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("Her mouth moves a few times before she finds the words she’s looking for. “I don’t have your number.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("I tilt my head to the side and smirk.")]), _vm._v(" "), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line4"
    }
  }, [_c('p', {
    attrs: {
      "id": "p236"
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("The diesel engine on my big, black Ram roars as I drive through the darkened streets of Wilmington. I don’t even have a destination, but it doesn’t matter as my brain sprints through thoughts of Olive Alexander.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("I admit, the main thought is the highlight reel of me bending her over that desk of hers and stroking every inch of her body while I pound into her, making her scream my name. And not in that controlled, managed voice either. But, unfortunately, I know it would be more than that with Olive. It’s been seven years since I lost Elle, and I’ve been with other women since.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("But I’ve never craved one. Not like this. But I get the sense Olive wouldn’t be open to a one-night stand. And that’s "), _c('i', [_vm._v("all")]), _vm._v(" I’m capable of.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("The thing I’m really confused about though is my "), _c('i', [_vm._v("need")]), _vm._v(" to know what’s going on in that head of hers. For me, with women, it’s usually about sex. I get in and I get out, because it’s just easier that way. Keeps shit simple. But with Olive? There’s this need to know what makes her tick. No one can keep that kind of pent-up energy perfectly controlled, the way she does, forever. It’s like she’s juggling two too many balls in the air, and she’s getting ready to drop the whole set.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("I want to be there when she does. I have a feeling she’s going to need someone around to help her catch them.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("And then there’s the fact that Jeremy asked me to look into what’s going on with her while he’s gone. He knew damn well she wouldn’t want me “keeping an eye on her.” She’s way too strong and independent to want any part of that. And that’s maybe the biggest turn-on of all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("But she’s also sad. Or discontent. The look on her face when I asked about Europe, the way her stance changed, her whole demeanor was different afterward. I’ve been trained to read people. I’ve been trained to hurt people.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("But I’ve also been trained to protect people.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_c('i', [_vm._v("There are some people even you aren’t able to protect. ")]), _vm._v("The thought forces its way into my brain unbidden, and I grip the steering wheel tighter as I try with everything I have to push those images out of my head. The thoughts that threaten to poison me with their potency every time I let them take over.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("Not tonight.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("I picture Olive, instead, and the thought puts a smile on my face.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("I pull the truck into the parking lot of my favorite bar, The Oakes. It’s not too far from my oceanfront condo. The bartender, Bennett Blacke, has become something like a friend, his military background bonding us.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("As I walk in I notice that the bar is quiet on this Monday night and television is tuned to the football game that’s about to kick off.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("Bennett leans toward me, his expression friendly as his straw-colored hair falls over his forehead. As the manager of this place, he has free rein, and my first drink is always on him. More often than not, one drink is all I have, and in that case I leave him a generous tip to cover the drink and the gratuity.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("Bennett takes one look at my face and lifts a brow. “Looks like a Jager kind of night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("Grinning, I shake my head and pull my phone from my pocket to shoot Olive a quick text.")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "extract3"
    }
  }, [_c('p', {
    staticClass: "ext1-rw",
    attrs: {
      "id": "p253"
    }
  }, [_c('b', [_vm._v("Me: done with Ken yet?")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("There. Now she has my number. Up to her what she’ll do with it. Chuckling, I leave the phone on the bar. “Just a beer tonight, man. I might have somewhere to be later.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("Bennett’s eyebrow lifts and his eyes twinkle with curiosity. “For real? You done gone and got a date?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("I shake my head, grabbing the neck of the beer bottle he passes me and putting it to my lips. “She’s already on her date. She’ll be calling me after.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("Bennett throws his head back and laughs. “Then she’s a smart chick.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("I nod, sipping my beer as my thoughts flip back to a gorgeous redhead who holds herself so tall, who has a war going on behind her smile and a battle in her eyes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("Maybe she doesn’t have to fight it alone. The more I allow myself to think about her, the clearer the picture becomes. Olive, underneath me in my bed? It’s a good fucking picture. I like it way more than I should.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("My phone buzzes on the bar top and I pick it up.")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "extract4"
    }
  }, [_c('p', {
    staticClass: "ext1-rw",
    attrs: {
      "id": "p261"
    }
  }, [_c('b', [_vm._v("Olive: It’s date number five, if you must know. That means Ken comes in tonight.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("Why does that single line of text make me want to hurl my beer bottle at the wall? Or jump into my car and eat up the road until I’m pulling up in her driveway?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("It’s bullshit. I have no say who she does or doesn’t sleep with. I barely know her. If she wants to have the most boring vanilla fuck in the world with Ken then who am I to stop her?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("The truth hits me: to Olive, I’m no one. There’s absolutely no reason for me to stop her. Or for her to think I would want her to stop.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_c('i', [_vm._v("Fuck")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("I’m almost too lost in my thoughts to notice the "), _c('i', [_vm._v("whoosh")]), _vm._v(" of cold air that hits my back as the front door opens, or the way that Bennett stiffens in his stance behind the bar. But the laser-sharp focus in his eyes pulls me around to eye the newcomer walking in, and there’s trouble written all over him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("The man glances at me before situating himself on a barstool two seats away. His hair is shaggy, curling around his neck in light brown waves, and his face is half-covered with a few days’ dark shadow. It’s hard to tell his age, but I’d guess by the way his eyes crinkle at the corners as he squints up at Bennett he’s in his thirties. His casual dress doesn’t suggests that anything’s amiss; the worn jeans and flannel shirt combined with a warm vest just tell me he’s prepared for the North Carolina chill clinging to the air.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("Bennett stands with his arms folded, his eyes glued to the dude, though, and so I sit up and pay attention without making it obvious that I’m listening in.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("“I’ll take a beer.” The man’s voice is low and rough, and he lifts the brim of his trucker’s hat to brush the hair off his forehead.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("Bennett doesn’t move. “What are you doing here, Mick?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("Mick pulls off his cap and runs a hand through his hair as he sets it on the bar top. “It’s none of your goddamn business what I’m doin’ here. I said I want a beer.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("Bennett’s eyes narrow. “Does your dad know you’re in his bar?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("That question gets Mick’s attention, and he spreads both hands out along the bar and leans forward. “Just because you run this place for my old man doesn’t mean what I do is any goddamn business of yours. Get. Me. A. Beer.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("Bennett watches Mick for another minute, then shakes his head and tosses down the dish towel he’d been holding. I catch his eye as he reaches under the bar to grab a longneck bottle, but he gives me the smallest shake of his head possible. He doesn’t want me getting into it, and normally, I wouldn’t. But Bennett has become a friend and if he’s having trouble around the bar I want to know if there’s any way I can help him out.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_vm._v("“I’ll take another.” I nod at Bennett, and Mick’s eyes shift toward me. They’re cool and calculating, an icy shade of blue that drives straight to the heart of a person without really trying.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("I sip my beer, and so does Mick, but no one speaks again. I’ve never met the guy before tonight, but the way Bennett carries himself, mixed with the way Mick acts like he owns the place, I’m guessing that his presence is gonna be nothing but trouble for Bennett.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("Finally, he turns to me and sticks out a hand. Without blinking, I shake it and wait for his introduction. “Mick.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("His mouth twists into what’s supposed to be a grin, but it seems like he’s gotten it wrong so many times he can’t figure out how to truly smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("“Ronin Shaw. I’m a friend of Bennett’s. You got business here tonight?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("An ominous shadow passes through the blue of Mick’s eyes. It doesn’t give me a good feeling in my gut, though. If anything, it makes me feel sick inside. But the flash is gone before I can comment on it, and Mick’s shifty grin is back I place.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p281"
    }
  }, [_vm._v("“You can call me the owner.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p282"
    }
  }, [_vm._v("Bennett slams down the glass he’s been cleaning. “Bullshit. Your father owns this place, Mick, not you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_vm._v("Mick chuckles, a rusty sound coming from deep within his throat. “He didn’t tell you? Thought you two were thick as thieves with all your old army connections and shit. Dad can’t handle this place anymore. That’s why he’s handing over ownership to me. Expect some changes in the coming weeks, "), _c('i', [_vm._v("Bennett")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("Bennett adopts a stance that suggests he could throttle over the bar top at any moment to plant a fist into Mick’s face. “Whatever you’re up to, Mick, just forget about it. It’s not happening in this bar, and it’s not happening to the good man who raised you.” He points from his gaze to Mick’s with two fingers. “I’ll be watching you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_vm._v("Mick slides his empty beer bottle forward and stands. “Ain’t nothin’ you can do to me, Blacke, that ain’t already been done. So just get used to seeing my face. Because I own this bar now.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("He pushes off his stool, aims one more curious glance in my direction before sneering at Bennett, and then walks out the front door.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_vm._v("Bennett sighs, and I glance at him. “What the hell was that about?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("He leans back against the wall, folding his arms across his chest and stares at the front doors. “That…is a fucking grenade just waiting to explode.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dcd91c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s007-Chapter-003.vue
// module id = 78
// module chunks = 0